import { freightPickupAccessorialPresetIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const setDefaultFreightPickupAccessorialPreset = {
  name: "setDefaultFreightPickupAccessorialPreset" as const,
  input: z.object({ id: freightPickupAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
